/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Post_Logistics_Shipping_AddressInputs */

const en_post_logistics_shipping_address = /** @type {(inputs: Post_Logistics_Shipping_AddressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Post-Logistics / Shipping Address`)
};

const es_post_logistics_shipping_address = /** @type {(inputs: Post_Logistics_Shipping_AddressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Post-Logística / Dirección de Envío`)
};

const fr_post_logistics_shipping_address = /** @type {(inputs: Post_Logistics_Shipping_AddressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Post-Logistique / Adresse d'expédition`)
};

const de_post_logistics_shipping_address = /** @type {(inputs: Post_Logistics_Shipping_AddressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Post-Logistik / Lieferadresse`)
};

const id_post_logistics_shipping_address = /** @type {(inputs: Post_Logistics_Shipping_AddressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pasca-Logistik / Alamat Pengiriman`)
};

/** @type {(inputs: Post_Logistics_Shipping_AddressInputs) => LocalizedString} */
const ja_post_logistics_shipping_address = en_post_logistics_shipping_address;

/** @type {(inputs: Post_Logistics_Shipping_AddressInputs) => LocalizedString} */
const zh_post_logistics_shipping_address = en_post_logistics_shipping_address;

/** @type {(inputs: Post_Logistics_Shipping_AddressInputs) => LocalizedString} */
const ar_post_logistics_shipping_address = en_post_logistics_shipping_address;

/** @type {(inputs: Post_Logistics_Shipping_AddressInputs) => LocalizedString} */
const it_post_logistics_shipping_address = en_post_logistics_shipping_address;

/** @type {(inputs: Post_Logistics_Shipping_AddressInputs) => LocalizedString} */
const ru_post_logistics_shipping_address = en_post_logistics_shipping_address;

/** @type {(inputs: Post_Logistics_Shipping_AddressInputs) => LocalizedString} */
const pt_post_logistics_shipping_address = en_post_logistics_shipping_address;

/** @type {(inputs: Post_Logistics_Shipping_AddressInputs) => LocalizedString} */
const ko_post_logistics_shipping_address = en_post_logistics_shipping_address;

/**
* | output |
* | --- |
* | "Post-Logistics / Shipping Address" |
*
* @param {Post_Logistics_Shipping_AddressInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const post_logistics_shipping_address = /** @type {((inputs?: Post_Logistics_Shipping_AddressInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Post_Logistics_Shipping_AddressInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_post_logistics_shipping_address(inputs)
	if (locale === "es") return es_post_logistics_shipping_address(inputs)
	if (locale === "fr") return fr_post_logistics_shipping_address(inputs)
	if (locale === "de") return de_post_logistics_shipping_address(inputs)
	if (locale === "ja") return ja_post_logistics_shipping_address(inputs)
	if (locale === "zh") return zh_post_logistics_shipping_address(inputs)
	if (locale === "ar") return ar_post_logistics_shipping_address(inputs)
	if (locale === "id") return id_post_logistics_shipping_address(inputs)
	if (locale === "it") return it_post_logistics_shipping_address(inputs)
	if (locale === "ru") return ru_post_logistics_shipping_address(inputs)
	if (locale === "pt") return pt_post_logistics_shipping_address(inputs)
	return ko_post_logistics_shipping_address(inputs)
});